import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterProvinceSearch = () => {
  const provinceSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-province/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { provinceSearch }
}

export default InteractorMasterProvinceSearch
